import { createSlice } from '@reduxjs/toolkit';

export const app = createSlice({
    name: 'app',
    initialState: {
        applicants: [],
        students: [],
        teachers: [],
        attendances: [],
        classrooms: [],
        subjects: [],
        appError: null,
    },
    reducers: {
        setApplicants: (state, action) => {
            state.applicants = action.payload;
        },
        setStudents: (state, action) => {
            state.students = action.payload;
        },
        setTeachers: (state, action) => {
            state.teachers = action.payload;
        },
        setAttendances: (state, action) => {
            state.attendances = action.payload;
        },
        setClassRooms: (state, action) => {
            state.classrooms = action.payload;
        },
        setSubjects: (state, action) => {
            state.subjects = action.payload;
        },
        setAppError: (state, action) => {
            state.appError = action.payload;
        },
    },
});

export default app.reducer;
export const {
    setApplicants,
    setStudents,
    setTeachers,
    setAttendances,
    setClassRooms,
    setSubjects,
    setAppError,
} = app.actions;
